// removed by extract-text-webpack-plugin
module.exports = {"badgesList":"_1lpB2"};